import { useGSAP } from '@gsap/react';
import BPSpinner from 'components/BionicUI/loading/BPSpinner';
import { DateTime } from 'luxon';
import { FC, useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

interface NotificationProps {
  notification: Notify;
  idx: number;
}

export type Notify = {
  initiator: string;
  iconImageUrl: string;
  datetimeISO: string;
  message: string;
};

const Notification: FC<NotificationProps> = ({ notification, idx }) => {
  const button = useRef<HTMLButtonElement>(null);

  useGSAP(() => {
    gsap.set(button.current, { opacity: 0 });
    gsap.to(button.current, {
      duration: 0.3,
      delay: idx * 0.05,
      opacity: 1,
      // scale: 1,
      ease: 'power3.out',
    });
  }, []);

  return (
    <button
      ref={button}
      className="grid relative w-full grid-cols-[auto_1fr] gap-3 text-[12px] font-semiBold bg-white/20 rounded-[8px] p-[15px] object-cover text-left items-start hover:scale-105"
    >
      <IconImage url={notification.iconImageUrl} />
      <div className="grid relative grid-flow-row gap-1">
        <div className="grid relative grid-cols-[1fr_auto] gap-2">
          <div className="block relative text-bionic-muted text-[10px] font-semiBold uppercase tracking-widest">
            {notification.initiator}
          </div>
          <div className="block relative text-bionic-muted text-[10px]">
            {DateTime.fromISO(notification.datetimeISO).toRelative({
              base: DateTime.now(),
            })}
          </div>
        </div>
        <div className="block relative text-white">{notification.message}</div>
      </div>
    </button>
  );
};

const IconImage: FC<{ url: string }> = ({ url }) => {
  const [srcUrl, setSrcUrl] = useState<string | null>(null);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setSrcUrl(url);
    img.src = url;
  }, []);

  return (
    <div className="grid relative w-[36px] h-[36px] rounded-[4px] justify-center items-center overflow-hidden">
      {srcUrl ? (
        <img
          src={url}
          alt="icon"
          className="block relative w-full h-full object-cover animate-fade-in"
        />
      ) : (
        <div className="grid relative w-full h-full justify-center items-center">
          <BPSpinner width={18} />
        </div>
      )}
    </div>
  );
};

export default Notification;
